import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const g = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-hangqing", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: g, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-è¡æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M15.17 7.113a.8.8 0 0 1 .141 1.122l-2.249 2.902c-.602.761-1.712.9-2.487.302l-.005-.005-1.774-1.396a.175.175 0 0 0-.246.032l-2.312 3.002a.8.8 0 1 1-1.268-.976l2.313-3.004a1.775 1.775 0 0 1 2.493-.318l.005.004 1.774 1.396c.08.06.192.044.25-.028l2.242-2.891a.8.8 0 0 1 1.122-.142Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.125 6.319A4.175 4.175 0 0 1 6.3 2.144h8.1c1.71 0 3.18 1.028 3.825 2.5a4.1 4.1 0 0 1 3.65 4.075v7.012a5.75 5.75 0 0 1-5.75 5.75H8.287a3.688 3.688 0 0 1-3.66-3.236 4.176 4.176 0 0 1-2.502-3.826v-8.1Zm4.234 12.275a2.088 2.088 0 0 0 1.928 1.287h7.838a4.15 4.15 0 0 0 4.15-4.15V8.72a2.503 2.503 0 0 0-1.7-2.37v8.402a3.843 3.843 0 0 1-3.843 3.843H6.359ZM6.3 3.744a2.575 2.575 0 0 0-2.575 2.575v8.1A2.575 2.575 0 0 0 6.3 16.994h8.432a2.243 2.243 0 0 0 2.243-2.243V6.319A2.575 2.575 0 0 0 14.4 3.744H6.3Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
